<div style="text-align-last: center;">
  <h1>{{'Leave Requests' | translate | async}}</h1>
</div>

<mat-card style=" margin-left: 2%;margin-right: 2%;">

  <span class="material-icons" style="float: right; font-size: 27px; cursor: pointer;" (click)="OpenNewLeaveRequest()">edit_square</span>
  <div class="search-options"
    style="min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;">

    <mat-form-field class="header-form-full-width">
      <input matInput [matDatepicker]="startDatePicker" placeholder="{{'Start Date' | translate | async }}" [(ngModel)]="startDate">
      <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #startDatePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="header-form-full-width">
      <input matInput [matDatepicker]="endDatePicker" placeholder="{{'End Date'  | translate | async}}" [(ngModel)]="endDate">
      <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #endDatePicker></mat-datepicker>
    </mat-form-field>

    <div class="header-form-full-width">

    </div>

    <div class="header-form-full-width">

    </div>

  </div>

  <div class="search-options-cell">
    <div style="display: flex;flex-direction: row;justify-content: flex-end;">
        <a class="button" (click)="ResetFields()">
            <span class="button__text">{{'Reset'  | translate | async}}</span></a>
        <a class="button button--primary" (click)="SearchLeaves()">
            <span class="button__text"> {{'Search'  | translate | async}}</span>
            <i class="material-icons button__icon">search</i>
        </a>
    </div>
</div>
</mat-card>

<table id="table_detail" cellpadding=10 class="table table--full-width table--striped" style="margin-left: 2%;">

  <tr>
      <th>{{'Leave Type'  | translate | async}}</th>
      <th>{{'Attachment'  | translate | async}}</th>
      <th style="padding: 0px 24px;">{{'Leave From'  | translate | async}} </th>
      <th style="padding: 0px 24px;">{{'Leave To'  | translate | async}}</th>
      <th style="padding: 0px 24px;">{{'Status'  | translate | async}} </th>
      <th style="padding: 0px 24px;">{{'Administration By'  | translate | async}} </th>
      <th></th>

  </tr>
  <ng-container  *ngFor="let sr of LeaveRequestList">
      <tr style="cursor: pointer;">

          <td  style="cursor: pointer;"  (click)="LoadLeaveInfo(sr)">{{sr.LeaveType}}</td>
          <td  style="cursor: pointer;"  (click)="LoadLeaveInfo(sr)"> 
            <i *ngIf="sr.Attachment!=''" style="cursor: pointer;vertical-align: bottom; margin-left: 10%;font-size: 40px; color: #3da14b;"
            class="material-icons" class="material-icons" (click)="onClickDownloadForm()">description</i>
        </td>
          <td  style="cursor: pointer;" (click)="LoadLeaveInfo(sr)">{{sr.LeaveFrom | date:'dd MMM yyyy'}}</td>
          <td  style="cursor: pointer;" (click)="LoadLeaveInfo(sr)">{{sr.LeaveTo | date:'dd MMM yyyy'}}</td>
          <td  style="cursor: pointer;" (click)="LoadLeaveInfo(sr)">{{sr.Status}}</td>
          <td style="cursor: pointer;" (click)="LoadLeaveInfo(sr)">{{sr.ApprovedUser}}</td> 

         


          <td>
              <i style="cursor: pointer;" *ngIf="sr.IsExpand" class="material-icons ttmodal__close-button"
              (click)="ChangeExpand(sr)" matTooltip="Show Less">expand_less</i>
              <i style="cursor: pointer;" *ngIf="!sr.IsExpand" class="material-icons ttmodal__close-button"
              (click)="ChangeExpand(sr)" matTooltip="Show More">expand_more</i>
          </td>


      </tr>
      <tr>
          <td colspan=6>
              <table class="table table--full-width table--striped" *ngIf="sr.IsExpand"
                  style="margin-left: 2%; border: groove;">
                  <thead>
                      <tr>
                          <th  style="padding: 0px 24px;width: 10%;"> {{'Date' | translate | async}}</th>
                          <th style="padding: 0px 24px;width: 10%;">{{'Action'  | translate | async}}</th>
                          <th style="padding: 0px 24px;width: 10%;">{{'User' | translate | async}} </th>            
                          <th style="padding: 16px 24px;width: 10%;;"> {{'Field Change'  | translate | async}}</th>
                          <th style="padding: 16px 24px;width: 10%;;"> {{'From'  | translate | async}}</th>
                          <th style="padding: 16px 24px;width: 10%;;">{{'To'  | translate | async}} </th>
                          

                      </tr>
                  </thead>
                  <tbody>
                      <ng-container  *ngFor="let audit of sr.LeaveAuditTrail">
                          <tr> 
                              <td >{{audit.ActionDate | date:'dd/MMM/yyyy'}}</td>
                              <td> {{audit.Action}}</td>
                              <td  >{{audit.UserName}}</td>
                              <td>{{audit.FieldChange}}</td>
                              <td> {{audit.ChangeFrom}}</td>
                              <td> {{audit.ChangeTo}}</td>
                          </tr>

                      </ng-container>
                  </tbody>

              </table>
          </td>

      </tr>
  </ng-container>

</table>